<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/pelanggan`"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Pelanggan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1"
            style="min-height: calc(100vh - 220px);">
            <v-col 
              cols="12"
              class="py-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-card v-if="process.load && Object.keys(detail).length < 1"
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-card-text
                      class="pb-0 my-4" style="min-height: calc(100vh - 320px); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>
                  </v-card>
    
                  <div v-if="!process.load && Object.keys(detail).length > 0" class="px-4">
                    <v-card 
                      flat
                      class="mb-5">

                      <div class="fs-18 font-weight-bold black_one ">
                        Informasi Pelanggan
                      </div>
                      <!-- <v-card-text> -->
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-card 
                              flat>
                              <div
                                style="width: 100%">
                                <v-card
                                  flat
                                  class="mb-4"
                                  style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                  <v-card-text class="pt-3">
                                    <div class="mb-1">
                                      Nama Pelanggan
                                    </div>
                                    <div class="fs-20 font_weight_600 black_one">
                                      {{ detail.name }}
                                    </div>
                                  </v-card-text>
                                </v-card>  
                                <div>
                                  <v-card 
                                    flat
                                    height="150"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
              
                                    <v-img
                                      contain
                                      height="150"
                                      :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url" 
                                      alt="POS Amanata"
                                      class="text-center d-flex align-center">
                                      <!-- <div 
                                        class="d-flex aling-center justify-center" 
                                        style="width: 100%; height: auto;">
                                        <v-icon v-if="!process.image"
                                          size="60" 
                                          color="white">
                                          mdi-cloud-upload-outline
                                        </v-icon>
              
                                        <v-progress-circular v-else
                                          indeterminate
                                          :color="set_color">
                                        </v-progress-circular>
                                      </div> -->
                                    </v-img>
                                  </v-card>
                                </div>
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-card 
                              flat
                              height="100%"
                              class="mb-5"
                              style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                              <v-card-text class="pb-0">
                                <v-row>
                                  <v-col class="py-0" cols="12">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          No. Telepon
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one">
                                          {{ detail.mobilephone }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Email
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.email }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12">
                                    <div class="mb-0">
                                      <div>
                                        <div>
                                          Deskripsi / Keterangan
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.note }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                  <!-- <v-col class="py-0" cols="6">
                                    <div class="mb-6">
                                      <div>
                                        <div>
                                          Satuan
                                        </div>
                                        <div class="fs-16 font_weight_600 black_one text-capitalize">
                                          {{ detail.satuan }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col> -->
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      <!-- </v-card-text> -->
                    </v-card>

                    <!-- <v-card 
                      flat
                      class="mb-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                      <v-card-text>
                        <div class="fs-18 font-weight-bold black_one mb-6">
                          Informasi Stok
                        </div>
                        <v-row>
                          <v-col class="py-0" cols="6">
                            <div class="mb-6">
                              <div>
                                <div>
                                  Stok Minimal
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ detail.stock_min*1 }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col class="py-0" cols="6">
                            <div class="mb-6">
                              <div>
                                <div>
                                  Stok
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ detail.stock*1 }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card> -->
                    <!-- <v-row>
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mb-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                          <v-card-text>
                            <div class="fs-18 font-weight-bold black_one mb-6">
                              Informasi Harga
                            </div>
                            <v-row>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Harga Beli
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.hpp | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Harga Jual
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.selling_price | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mb-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                          <v-card-text>
                            <div class="fs-18 font-weight-bold black_one mb-6">
                              Informasi Diskon
                            </div>
                            <v-row>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Diskon (Persen)
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.discount_percent*1 }} %
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col class="py-0" cols="6">
                                <div class="mb-6">
                                  <div>
                                    <div>
                                      Diskon (Rupiah)
                                    </div>
                                    <div class="fs-16 font_weight_600 black_one">
                                      {{ detail.discount_value*1 | price }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>


                    <v-card 
                      flat
                      class="mb-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                      <v-card-text>
                        <div class="fs-18 font-weight-bold black_one mb-6">
                          Gambar Produk
                        </div>
                        <v-row>
                          <v-col class="py-0" cols="12">
                            <div
                              style="height: 250px; width: 250px">
                              <div>
                                <v-card 
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
            
                                  <v-img
                                    contain
                                    height="250"
                                    :src="detail.image_url" 
                                    :alt="detail.image_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
            
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card> -->
                  </div>
                </v-form>
              </ValidationObserver>


              <v-card flat class="mt-5">
                <v-card-text>
                  <v-divider class="mb-8"></v-divider>
                  <div class="fs-18 font-weight-bold black_one mb-4">
                    Riwayat Transaksi
                  </div>
                  <v-row>
                    <v-col 
                      cols="12"
                      class="py-0">
                      <v-card 
                        flat
                        style="border-radius: 10px; border: 1px solid #E7E7E7;">
                        <v-data-table
                          v-model="selected.row"
                          ref="table-grid"
                          class="table-grid"
                          :height="`calc(100vh - ${pagination.total_data > 0 ? '470px' : '248px'})`"
                          :show-select="checkbox"
                          :single-select="true"
                          :loading="process.list"
                          loading-text="Sedang memuat data . . ."
                          loader-height="5"
                          no-results-text="Belum ada data"
                          :options.sync="options"
                          :headers="configHeaders"
                          :items="list"
                          :items-per-page="100"
                          item-key="id"
                          @click:row="rowClick"
                          @toggle-select-all="handleToggleAll($event)"
                          @dblclick:row="doubleClick"
                          hide-default-footer>
                          <template
                            v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                              v-slot:[`item.${header.value}`]="{ value }">
                            <div
                              v-bind:key="header.value">
                              <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                {{ rowFormat(header.format, value) }} 
                              </div>
  
                              <div v-if="header.format === 'link'"
                                class="text-capitalize">
                                {{ value }}
                              </div>
                
                              <div v-if="header.format === 'regex'">
                                <span
                                  class="two-line">
                                  {{ rowFormat(header.format, value) }}
                                </span>
                              </div>
                
                              <div v-if="header.format === 'image'"
                                class="ma-4">
                                <v-avatar
                                  size="60"
                                  tile
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <v-img 
                                    contain
                                    width="100%"
                                    height="100%"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-avatar>
                              </div>
  
                              <div v-if="header.format === 'image_potrait'"
                                class="ma-4">
                                <v-img 
                                  contain
                                  width="100"
                                  height="125"
                                  alt="POS Amanata" 
                                  :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
  
                              <div v-if="header.format === 'image_landscape'"
                                class="ma-4">
                                <v-img 
                                  contain
                                  width="200"
                                  height="125"
                                  alt="POS Amanata" 
                                  :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                  class="ma-auto"
                                  style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </div>
  
                              <div v-if="header.format === 'action'">
  
                                
                              </div>
                            </div>
                          </template>
  
                          <template v-slot:[`item.index`]="{ index }">
                            {{ lastIndex + index }}
                          </template>
  
                          <v-progress-linear 
                            v-show="process.load" 
                            slot="progress" 
                            color="white" 
                            indeterminate>
                          </v-progress-linear>
                        </v-data-table>
  
                        <pagination v-if="pagination.total_data > 0"
                          @changePage="fetch($event)" 
                          @reloadPage="fetch($event)" 
                          :model="pagination" :display="paginationList"/>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 px-5">
            <v-col 
            cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-space/>
              
              <v-btn
                :to="`/pelanggan`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Kembali
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],
        checkbox: false,
        dialog: {
          form: false,
          fullscreen: false
        
        },
        menu: {
          
        },
        modalTime: {
          
        },
        total_nominal: 0,
        form: {},
        detail: {},
        categoty_id: '',
        product: [],
        category: [],
        allCategory: [],
        satuan: [],
        menu2: false,
        menu1: false,
        location: [],
        show: false,
        paginationList: {},
        lastIndex: 0,
        limit: 20,
        options: {},
        headers: [],
        list: [],
        detail_item: [],
        pagination: {},
        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          form: 0
        },
        upload: {
          image: null
        },

        process: {
          form: false,
          load: false,

          image: false,
          table: false,
          list: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetchDetail()
      // this.fetch()
    },
    methods: {
      async fetchDetail (data) {
        this.process.load = true
        let params = {
          // limit: 1000000000,
          id: this.$route.params.id
        }
        
        await get('pos/customer/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.process.load = false
          }
        })
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.list = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          customer_id: this.$route.params.id,
          // search: this.search,
          // 'payment_datetime[gte]': this.filter.start_date,
          // 'payment_datetime[lte]': this.filter.end_date,
          // date: this.filter.date,
          outlet_id: this.outlet.outlet_id
        }

        this.selected.row = []

        await get(`pos/report/transaksi_history_customer`, { params })
        .then(response => {
          let res = response.data

          this.process.list = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Tanggal',
                width: '200px',
                value: 'payment_datetime',
                freeze: true,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'No Transaksi',
                // width: '200px',
                value: 'so_trans_number',
                freeze: false,
                hide: false
              },
              {
                text: 'Tipe Penjualan',
                // width: '200px',
                value: 'type_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Metode Bayar',
                // width: '200px',
                value: 'payment_method',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Pelanggan',
                // width: '200px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Harga Beli',
                // width: '200px',
                value: 'sub_total',
                freeze: false,
                hide: false,
                format: 'price'
              },
              {
                text: 'Total Diskon',
                // width: '200px',
                value: 'discount_total',
                freeze: false,
                hide: false,
                format: 'price'
              },
              {
                text: 'Total Pajak',
                // width: '200px',
                value: 'tax',
                freeze: false,
                hide: false,
                format: 'price'
              },
              {
                text: 'Biaya Lainnya',
                // width: '200px',
                value: 'other_costs',
                freeze: false,
                hide: false,
                format: 'price'
              },
              {
                text: 'Grand Total',
                // width: '200px',
                value: 'total',
                freeze: false,
                hide: false,
                format: 'price'
              },
              {
                text: 'Diinput Oleh',
                // width: '200px',
                value: 'payment_kasir_input_name',
                freeze: false,
                hide: false
              },
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination


            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'price') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'price') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
    }
  }
</script>